import React, {FC} from "react";
import {getFiat, truncate} from '../../../common/utils/function';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TokenImage from "../token-image";

interface market {
    extra?: any;
    marketData?: any;
}

const MarketTable: FC<market> = (props) => {
    const {t} = useTranslation();
    const fiat = useSelector((e: Object) => (e as any)?.common?.fiat) || "usd";

    const coingeckoData = props?.marketData?.coingecko_data;
    const marketData = coingeckoData?.market_data || {};
    const marketDataList = coingeckoData?.tickers || [];
    const totalVolume = marketData.total_volume?.usd || 1;

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="bs-card h-100">
                    <div className="bs-card-body p-3">
                        <div className="d-flex align-items-center justify-content-between pb-1">
                            <h2 className="bs-card-header-title">
                                <div className="d-flex justify-content-between align-items-center pb-4">
                                    <div className="ms-2">
                                        <p className="mb-0 font-b text-muted">
                                            {t(`Total ${marketDataList.length} Pairs`)}
                                        </p>
                                    </div>
                                </div>
                            </h2>
                        </div>
                        <div className="pb-2">
                            <table className="bs-custom-table">
                                <thead className="bs-custom-table-header">
                                <tr>
                                    <th className="bs-custom-table-cell" scope="col">{t("#")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("Exchange")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("Pair")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("Price")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("Spread")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("24h Volume")}</th>
                                    <th className="bs-custom-table-cell" scope="col">{t("Volume %")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {marketDataList.map((ticker: any, index: number) => (
                                    <tr key={index} className="bs-custom-table-row">
                                        <th className="bs-custom-table-cell" scope="row">{index + 1}</th>
                                        <td className="bs-custom-table-cell">
                                            <TokenImage image={ticker.image} symbol={ticker?.market?.identifier} params={{width: 20, className: "me-2 rounded-5"}}/>
                                            {ticker.market.name}
                                        </td>
                                        <td className="bs-custom-table-cell">
                                            <a href={ticker.trade_url} target="_blank" rel="noopener noreferrer">
                                                {ticker.base.startsWith("0X") ? ticker.coin_id : truncate(ticker.base)}/{ticker.target.startsWith("0X") ? ticker.target_coin_id : truncate(ticker.target)}
                                            </a>
                                            <TokenImage image={ticker?.coin_id} symbol={ticker.base.startsWith("0X") ? ticker.coin_id : ticker.base}
                                                        params={{width: 20, className: "ms-2 rounded-5"}}/>
                                            <TokenImage image={ticker?.coin_id} symbol={ticker.base.startsWith("0X") ? ticker.target_coin_id : ticker.target}
                                                        params={{width: 20, className: "ms-1 rounded-5"}}/>
                                        </td>
                                        <td className="bs-custom-table-cell">{getFiat(ticker.converted_last.usd, 6, fiat, true)}</td>
                                        <td className="bs-custom-table-cell">{ticker.bid_ask_spread_percentage?.toFixed(2)}%</td>
                                        <td className="bs-custom-table-cell">{getFiat(ticker.converted_volume.usd, 6, fiat, true)}</td>
                                        <td className="bs-custom-table-cell">{((ticker.converted_volume.usd / totalVolume) * 100).toFixed(2)}%</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MarketTable;